export default "__VITE_ASSET__30ae0c06__"